import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import classNames from 'classnames'
import IcomoonReact from 'icomoon-react'
import { isEmpty } from 'lodash'
import { checkPathPresent } from 'src/utils/helpers/GeneralHelpers'
import { useGlobalContext } from 'src/stores/GlobalContext'
import rebrandIconSet from 'src/assets/icons/rebrandIconList.json'
import variables from 'src/assets/styles/variables.module.scss'
import navStyles from './navigation.module.scss'

const BackNavigation = ({ showScannerButtons }) => {
  const navigate = useNavigate()
  const { currentEvent } = useGlobalContext()
  const { pathname, search, state } = useLocation()
  const scannerActive = pathname.includes('scanner')
  const qrActive = pathname.includes('qr-code')

  const PATH = `/programs/${currentEvent.id}`

  const handleBackClick = () => {
    if (checkPathPresent(['scanner', 'qr-code'], pathname)) {
      if (isEmpty(search) && state?.bizCardScannedReturnPath) {
        navigate(`${PATH}/leaderboard`) // Navigate back to leaderboard only if from leaderboard
      } else if (isEmpty(search)) {
        navigate(`${PATH}`)
      } else if (search === '?attendees') {
        navigate(`${PATH}/attendees`)
      } else if (search === '?sponsors') {
        navigate(`${PATH}/sponsors`)
      } else {
        navigate(-1)
      }
    } else {
      navigate(-1)
    }
  }

  return (
    <div
      className={classNames(
        navStyles.headerNavContainer,
        navStyles.backNavContainer
      )}
    >
      <button
        className={navStyles.backButton}
        onClick={() => handleBackClick()}
      >
        <IcomoonReact
          iconSet={rebrandIconSet}
          color={variables.c01lightBase006ac7}
          size={24}
          icon="Controls-Back"
        />
      </button>
      {showScannerButtons && (
        <>
          <div
            className={classNames(navStyles.navItemContainer, {
              [navStyles.active]: qrActive
            })}
          >
            <button
              className={classNames(navStyles.iconContainer, {
                [navStyles.iconContainerActive]: qrActive
              })}
              data-title="My QR Code"
              onClick={() =>
                navigate(
                  `/programs/${currentEvent.id}/qr-code${search || ''}`,
                  {
                    // Pass the state so we can keep track of if we came from leaderboard
                    state: {
                      ...state,
                      bizCardScannedReturnPath: state?.bizCardScannedReturnPath
                    }
                  }
                )
              }
            >
              <IcomoonReact
                iconSet={rebrandIconSet}
                color={
                  qrActive
                    ? variables.c03lightActive264a82
                    : variables.c01lightBase006ac7
                }
                size={24}
                icon={'QR'}
              />
            </button>
          </div>
          {currentEvent.is_attended && (
            <div
              className={classNames(navStyles.navItemContainer, {
                [navStyles.active]: scannerActive
              })}
            >
              <button
                className={classNames(navStyles.iconContainer, {
                  [navStyles.iconContainerActive]: scannerActive
                })}
                data-title="Scanner"
                onClick={() =>
                  navigate(
                    `/programs/${currentEvent.id}/scanner${search || ''}`,
                    {
                      // Pass the state so we can keep track of if we came from leaderboard
                      state: {
                        ...state,
                        bizCardScannedReturnPath:
                          state?.bizCardScannedReturnPath
                      }
                    }
                  )
                }
              >
                <IcomoonReact
                  iconSet={rebrandIconSet}
                  color={
                    scannerActive
                      ? variables.c03lightActive264a82
                      : variables.c01lightBase006ac7
                  }
                  size={24}
                  icon={'Scanner'}
                />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  )
}

export default BackNavigation

// Back nav ONLY
// - Attendee detail
// - Speaker detail
// - Governing Body detail
// - Partner detail
// - Leaderboard ranking
// - Event evaluation
